module.exports = __webpack_public_path__ + "images/stickers/pete-completed.213df9ec14509a7f0628.png";